import { CloudinaryType } from '@fm-nx/contentful-types';
import { CldImage } from 'next-cloudinary';
import classNames from 'classnames';

type ClientLogoPropTypes = {
    image: CloudinaryType;
    mode?: 'light' | 'dark' | 'black';
};
export const ClientLogo = (props: ClientLogoPropTypes) => {
    const { image, mode } = props;

    if (!image) return null;

    return (
        <CldImage
            src={`${image.public_id}`}
            width={200}
            height={200}
            format={image.format}
            quality="auto"
            className={classNames('w-full h-full object-contain', {
                'brightness-0 invert': mode === 'dark',
                'opacity-50 grayscale': mode === 'light',
                grayscale: mode === 'black',
            })}
            alt={image.context?.custom?.['alt'] || ''}
            loading="lazy"
        />
    );
};
export default ClientLogo;
